
function MenuIcon({}: {}) {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 12.5H23" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
			<path d="M1 5.5H23" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
			<path d="M1 19.5H23" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
		</svg>
	);
}

export default MenuIcon;
